import Fragment from "../../football/fragments/fragment";
import FragmentDataType from "../../football/enums/fragment-data-type";
import { playerReducer } from "../../../storage/reducers";
import FragmentSummary from "../../football/fragments/fragment-summary";

export default class FlagPatPass extends Fragment {
    constructor(passedBy, passedTo) {
        super();

        this.patType = "P";
        this.passedBy = passedBy;
        this.passedTo = passedTo;

        this.requiredData = [
            {
                name: "passedBy",
                type: FragmentDataType.Player,
                displayName: "Passed By",
                title: (team) => `Passed By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true
            },
            {
                name: "passedTo",
                type: FragmentDataType.Player,
                displayName: "Passed To",
                title: (team) => `Passed To: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true
            }
        ];
    }

    getFragmentTeamId() {
        return this.passedBy?.teamId;
    }

    getPlayers() {
        return [this.passedBy];
    }

    summarize(summaryContext, stringifier) {
        const message = `${stringifier.firstInitial(this.passedBy)} ${
            summaryContext.patPoints
        }-point pass attempt`;

        return new FragmentSummary(message);
    }

    toJSON() {
        return {
            ...super.toJSON(),
            passedBy: playerReducer(this.passedBy)
        };
    }
}
